import { render } from "./navbar.vue?vue&type=template&id=1dc0d3df"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/john/Desktop/projects/vue_js_projects/portfolio-tailwind/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__